import { StatusPageSummary } from './Summary'
import { useTranslation } from 'react-i18next'
import { useStatusPageQuery } from './StatusPage.generated'
import { StatusPageComponents } from './StatusPageComponents'
import Wrapper, { LoadingWrapper } from '../../../../utils/Wrapper'

export function StatusPageList() {
  const [t] = useTranslation('common')
  const { data } = useStatusPageQuery({
    fetchPolicy: 'cache-and-network',
  })

  if (!data?.Profile)
    return (
      <LoadingWrapper
        title={t('status_page.title')}
        subtitle={t('status_page.main_desc')}
      />
    )

  return (
    <Wrapper
      title={t('status_page.title')}
      subtitle={t('status_page.main_desc')}
    >
      <div>
        <StatusPageSummary
          summary={data.Profile.statusPage.summary}
          components={data.Profile.statusPage.components}
        />
        <StatusPageComponents
          groups={data.Profile.statusPage.componentGroups}
          components={data.Profile.statusPage.components}
        />
      </div>
    </Wrapper>
  )
}
